import clsx from "clsx";
import { useEffect, useMemo, useState } from "react";
import { createUseStyles } from "react-jss";
import { currentAccount } from "../../../proxies";
import { fetchApi } from "../../../services/api";

const useStyles = createUseStyles(theme => ({
  loading: {
    "text-align": "center",
    color: "white",
  },
  teams: {
    display: "flex",
    "flex-direction": "column",
    "align-items": "stretch",
    "max-height": props => (props.show ? props.height : 0),
    overflow: "hidden",
    transition: "max-height 0.2s ease",
  },
  team: {
    "text-transform": "uppercase",
    margin: [4, 0, 4, 10],
    "padding-left": 10,
    "border-left": "5px solid transparent",
    color: "#ccc",
    cursor: "pointer",
    transition: "border-color 0.1s ease",

    "&:hover": {
      "border-left-color": "#ccc",
      color: "white",
    },
  },
  active: {
    "border-left-color": `${theme.colorRed} !important`,
    color: "white",
  },
}));

const useTeams = account => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (account) {
      setLoading(true);
      fetchApi(`/teams/list/${account}`, { version: "v1" })
        .then(res => {
          setLoading(false);
          setTeams(res.sort((a, b) => (a.name || '').localeCompare(b.name || '')));
        })
        .catch(err => {
          setLoading(false);
          console.error(err);
        });
    }
  }, [account]);

  return [teams, loading];
};

const Teams = ({ account, active, setActive, show }) => {
  const [teams] = useTeams(account);
  const classes = useStyles({ show, height: (teams.length ?? 0) * 28 + 32 });

  const valid = teams.map(x => x.id).includes(active);
  const defaultTeam = useMemo(() => {
    const stored = parseInt(window.localStorage.getItem("latestTeam"), 10);
    let defaultTeam = null;
    if (teams.map(x => x.id).includes(stored)) {
      defaultTeam = teams.find(team => team.id === stored);
    } else if (teams.length > 0) {
      defaultTeam = teams[0];
    }
    return defaultTeam;
  }, [teams]);

  useEffect(() => {
    if (!valid && defaultTeam) {
      setActive(defaultTeam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTeam, valid]);

  useEffect(() => {
    if (active) {
      window.localStorage.setItem("latestTeam", active);
      currentAccount.team = active;
    }
  }, [active]);

  return (
    <div className={classes.teams}>
      {teams.map(team => (
        <div
          key={team.id}
          onClick={() => setActive(team)}
          className={clsx(classes.team, {
            [classes.active]: active === team.id,
          })}
        >
          {team.name}
        </div>
      ))}
      <hr />
    </div>
  );
};

export default Teams;
